import React, { useState } from "react";
import { Dimensions, Pressable, StyleSheet, useWindowDimensions, View, } from "react-native";
import { useSharedValue } from "react-native-reanimated";
import BaseCarousel, { Pagination, } from "react-native-reanimated-carousel";
import { getBreakpoint } from "../utils";
import { FAIcon } from "../../../components/elements";
import { getCarouselHeight } from "../utils/getCarouselHeight";
import { parallaxLayout } from "./paralax";
export const Carousel = ({ data, onLayout, autoplayLoop = true, autoplay: autoplayProp = false, autoplayDelay = 5, autoplayPause = 5, showPagination = false, displayCarded = false, extendedImages = false, contentWidth = Dimensions.get("window").width, contentHeight, style, renderItem, }) => {
    const dataArray = Array.isArray(data) ? data : Array.from(data ?? []);
    const { height: windowHeight, width: windowWidth } = useWindowDimensions();
    const ref = React.useRef(null);
    const progress = useSharedValue(0);
    const onPressPagination = (index) => {
        ref.current?.scrollTo({
            count: index - progress.value,
            animated: true,
        });
    };
    const [mouseOver, setMouseOver] = useState(false);
    const isDesktop = getBreakpoint(contentWidth) === "desktop";
    const isCardMode = displayCarded && !isDesktop;
    const isExtendedImagesMode = extendedImages && !isCardMode;
    const carouselHeight = contentHeight || getCarouselHeight(windowWidth, windowHeight);
    return (React.createElement(View, { style: {
            width: contentWidth,
            height: carouselHeight,
            maxWidth: "100%",
            overflow: isExtendedImagesMode ? "visible" : "hidden",
        }, onLayout: onLayout, onPointerEnter: () => {
            setMouseOver(true);
        }, onPointerLeave: () => {
            setMouseOver(false);
        } },
        React.createElement(View, { style: [
                style,
                { overflow: isExtendedImagesMode ? "visible" : "hidden" },
            ] },
            React.createElement(BaseCarousel, { onConfigurePanGesture: (gesture) => {
                    gesture.activeOffsetX([-10, 10]).failOffsetY([-10, 10]);
                }, windowSize: 3, ref: ref, autoPlay: !mouseOver && autoplayProp, loop: autoplayLoop, autoPlayInterval: autoplayDelay * 1000, width: contentWidth, height: carouselHeight, style: {
                    width: contentWidth,
                    height: carouselHeight,
                    overflow: isExtendedImagesMode ? "visible" : "hidden",
                }, customAnimation: isCardMode
                    ? parallaxLayout({
                        size: windowWidth,
                        vertical: false,
                    }, {
                        parallaxScrollingScale: isCardMode ? 0.8 : 1,
                        parallaxAdjacentItemScale: 0.5,
                        parallaxScrollingOffset: windowWidth * 0.37,
                    })
                    : undefined, data: dataArray, onProgressChange: progress, renderItem: renderItem })),
        showPagination && !isCardMode ? (React.createElement(View, { style: styles.paginationContainer },
            React.createElement(Pagination.Custom, { progress: progress, data: dataArray, size: 12, dotStyle: styles.dotStyle, activeDotStyle: styles.activeDotStyle, containerStyle: styles.containerStyle, horizontal: true, onPress: onPressPagination }))) : null,
        showPagination && mouseOver ? (React.createElement(View, { style: styles.navigationButtonsContainer },
            React.createElement(Pressable, { onPress: () => ref.current?.prev({ animated: true }), style: styles.navigationButtons },
                React.createElement(FAIcon, { name: "chevron-left", style: { color: "white" } })),
            React.createElement(Pressable, { onPress: () => ref.current?.next({ animated: true }), style: styles.navigationButtons },
                React.createElement(FAIcon, { name: "chevron-right", style: { color: "white" } })))) : null));
};
const styles = StyleSheet.create({
    paginationContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 16,
        position: "absolute",
        bottom: 15,
        width: "100%",
    },
    navigationButtonsContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingHorizontal: 8,
        position: "absolute",
        top: "50%",
        width: "100%",
    },
    navigationButtons: {
        width: 40,
        height: 40,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 100,
        backgroundColor: "#77777799",
    },
    dotStyle: {
        borderRadius: 16,
        backgroundColor: "#9C9D9BDF",
    },
    activeDotStyle: {
        borderRadius: 8,
        width: 30,
        height: 12,
        overflow: "hidden",
        backgroundColor: "#ffffffDF",
    },
    containerStyle: {
        gap: 10,
        marginBottom: 10,
        alignItems: "center",
        height: 10,
    },
});
//# sourceMappingURL=Carousel.js.map